import { Chip } from '@mui/material';
import { LinkToCompetition } from 'app/components/links/LinkToCompetition';
import React from 'react';
import styled from 'styled-components';
import ChipImage from 'app/components/chip/ChipImage';
const StyledChipImage = styled(ChipImage).withConfig({
  componentId: "sc-1vboe8y-0"
})(["img{padding:2px;}"]);
const StandingShortcut = _ref => {
  let {
    competition
  } = _ref;
  if (!competition) {
    return null;
  }
  const leagueLinkImage = competition !== null && competition !== void 0 && competition.image ? /*#__PURE__*/React.createElement(StyledChipImage, {
    entity: 'competition',
    src: competition.image,
    ratio: '1:1',
    fit: true
  }) : undefined;
  return /*#__PURE__*/React.createElement(Chip, {
    style: {
      display: 'flex'
    },
    avatar: leagueLinkImage,
    label: 'Zur Tabelle',
    variant: "outlined",
    clickable: true,
    component: LinkToCompetition,
    competition: competition,
    subpage: "standing",
    "data-sentry-element": "Chip",
    "data-sentry-component": "StandingShortcut",
    "data-sentry-source-file": "standingShortcut.tsx"
  });
};
export default StandingShortcut;